import {
  GET_PROJECT_QA_NDT_BOOKINGS_INSPECTORS,
  GET_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
  CREATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
  UPDATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
  DESTROY_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
} from "./actions";

export function ProjectQaNdtBookingsInspectorsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_QA_NDT_BOOKINGS_INSPECTORS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_QA_NDT_BOOKINGS_INSPECTOR}_FULFILLED`:
    case `${CREATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR}_FULFILLED`:
    case `${UPDATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_PROJECT_QA_NDT_BOOKINGS_INSPECTOR}_FULFILLED`: {
      let newState = _.clone(state);
      const deletedItem = action.payload.data;
      const id = _.get(deletedItem, "id");
      newState = _.filter(newState, (i) => i.id != id);
      return newState;
    }
    default:
      return state;
  }
}
